<template>
  <ul v-if="!mobile" ref="sidebar" class="navbar-nav sidebar sidebar-dark accordion akkurate-dark-gradient">
    <!-- Sidebar - Brand -->
    <a class="sidebar-brand d-flex align-items-start justify-content-center" href="/">
      <!-- <div class="sidebar-brand-icon">
                <font-awesome-icon :icon="['fas', 'layer-group']" />
            </div> -->
      <!-- image -->
      <img height="50px" src="../../../assets/img/logo.png" />
      <div class="sidebar-brand-text mx-3 mb-0 pb-0 text-start mt-auto">
        <div>AKKURATEBanc</div>
        <div style="color:#a4f5ec;" class="text-xs">{{ this.user_branch }}</div>
      </div>

    </a>

    <!-- Divider -->
    <hr class="sidebar-divider mt-0" />

    <!-- Nav Item - Dashboard -->
    <li class="nav-item" :class="{ active: home }">
      <a class="nav-link" href="/">
        <font-awesome-icon :icon="['fas', 'house-damage']" /><span>Dashboard</span>
      </a>
    </li>

    <hr class="sidebar-divider" />

    <div class="sidebar-heading">Member Management</div>

    <!-- Memebers -->
    <b-nav-item v-b-toggle.collapse-3 :class="{ active: members }">
      <font-awesome-icon :icon="['fas', 'users']" /><span>Members</span>
      <b-collapse id="collapse-3" :visible="memberVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link class="collapse-item" :class="{ active: addMember }" href="/members/create">Create Member</b-link>
          <b-link class="collapse-item" :class="{ active: allMember }" href="/members">
            <CustomTooltip :message="memberHoverDetailDiplay" :is-html="true" :background="'rgba(1, 134, 114, 0.6)'"
              :color="'#ffffff'" :offsetY="30">
              All Members
              <small class="ms-1" :class="statusBadge('Pending')">{{ memberData.pending_customer_count }}</small>
              <small class="ms-1" :class="statusBadge('Rejected')">{{ memberData.rejected_customer_count }}</small>

            </CustomTooltip>
          </b-link>
          <b-link class="collapse-item" :class="{ active: memberImport }" href="/members/import">Imports</b-link>
          <b-link class="collapse-item" :class="{ active: roTransfer }" href="/members/ro/transfer">Ro Transfer</b-link>
        </div>
      </b-collapse>
    </b-nav-item>

    <hr class="sidebar-divider" />

    <!-- Member Accounts -->
    <b-nav-item v-b-toggle.collapse-4 :class="{ active: memacc }">
      <font-awesome-icon :icon="['fas', 'user-circle']" /><span>Products</span>
      <b-collapse id="collapse-4" :visible="memaccVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link class="collapse-item" :class="{ active: addMemAcc }" href="/members/account/create">Create
            Product</b-link>
          <b-link class="collapse-item" :class="{ active: allMemAcc }" href="/members/account">
            <CustomTooltip :message="allProductHoverDetailDiplay" :is-html="true"
              :background="'rgba(1, 134, 114, 0.6) '" :color="'#ffffff'" :offsetY="30">
              All Products
              <!-- <small class="ms-1" :class="statusBadge('Approved')">{{ productData.account.active }}</small> -->
              <small class="ms-1" :class="statusBadge('Pending')">{{ productSummary.pending }}</small>
              <small class="ms-1" :class="statusBadge('Rejected')">{{ productSummary.closed }}</small>
            </CustomTooltip>
          </b-link>
          <b-link class="collapse-item" :class="{ active: importMembers }"
            href="/members/account/imports">Imports</b-link>
          <b-link class="collapse-item" :class="{ active: commissionTransfer }"
            href="/members/account/commission/transfer">Balance Transfer (Bulk)</b-link>
        </div>
      </b-collapse>
    </b-nav-item>

    <!-- Divider -->
    <hr class="sidebar-divider">
    <div class="sidebar-heading">
      Transactions
    </div>
    <!-- Operations -->
    <b-nav-item v-b-toggle.collapse-5 :class="{ active: transaction }">
      <font-awesome-icon :icon="['fas', 'money-bill']" /><span>Deposit/Withdrawal</span>
      <b-collapse id="collapse-5" :visible="transVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link class="collapse-item" :class="{ active: depositTransaction }"
            href="/transactions/deposit">Deposit</b-link>
          <b-link class="collapse-item" :class="{ active: withdrawalTransaction }"
            href="/transactions/withdrawal">Withdrawal</b-link>
          <!-- <b-link class="collapse-item" :class="{ active: bulkTransaction }" href="/transactions/deposits/bulk">Bulk
            Deposits</b-link> -->
          <!-- <b-link class="collapse-item" :class="{ active: bulkWithdrawals }" href="/transactions/withdrawals/bulk">Bulk
            Withdrawals</b-link> -->
          <b-link class="collapse-item" :class="{ active: allTransaction }" href="/transactions/all-deposit-withdrawal">
            <CustomTooltip :message="depositAndWithdrawalrHoverDetailDiplay" :is-html="true"
              :background="'rgba(1, 134, 114, 0.6) '" :color="'#ffffff'" :offsetY="30">
              All Deposits /<br /> Withdrawals
              <small class="ms-1" :class="statusBadge('Pending')">{{ depositAndWithdrawalData.count.pending }}</small>
              <small class="ms-1" :class="statusBadge('Rejected')">{{ depositAndWithdrawalData.count.reversed }}</small>
            </CustomTooltip>
          </b-link>

          <b-link class="collapse-item" :class="{ active: chequeProcessing }"
            href="/transactions/cheque-processing">Cheque Processing</b-link>

          <b-link class="collapse-item" :class="{ active: transactionImports }"
            href="/transactions/imports">Imports</b-link>
        </div>
      </b-collapse>
    </b-nav-item>
    <!-- Divider -->
    <hr class="sidebar-divider d-none d-md-block">

    <b-nav-item v-b-toggle.collapse-6 :class="{ active: operation }">
      <font-awesome-icon :icon="['fas', 'briefcase']" /><span>Operations</span>
      <b-collapse id="collapse-6" :visible="operationsVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link class="collapse-item" :class="{ active: standing_order }" href="/standing-order">Standing
            Orders</b-link>
          <b-link class="collapse-item" :class="{ active: fdScheme }" href="/investment/fixed-deposit-scheme">Fixed
            Deposit Scheme</b-link>
          <b-link class="collapse-item" :class="{ active: fixed_deposit }" href="/investment/fixed-deposit">
            <CustomTooltip :message="fixedDepositHoverDetailDiplay" :is-html="true"
              :background="'rgba(1, 134, 114, 0.6) '" :color="'#ffffff'" :offsetY="30">
              Fixed Term Deposits
              <small class="" :class="statusBadge('Pending')">{{ fixed_deposit_summary?.count?.pending }}</small>
              <small class="" :class="statusBadge('Rejected')">{{ fixed_deposit_summary?.count?.redeemed }}</small>
            </CustomTooltip>
          </b-link>
          <b-link class="collapse-item" :class="{ active: fixed_deposit_trans }"
            href="/investment/fixed-deposit/transactions">Fixed Term
            Transactions</b-link>

          <b-link class="collapse-item" :class="{ active: allTransaction }"
            href="/reports/controls/user-coa-tracker">Collection Tracker</b-link>

          <b-link class="collapse-item" :class="{ active: operationImport }" href="/operations/imports">Imports</b-link>
          <b-link class="collapse-item" :class="{ active: termDepositsReports }"
            href="/reports/fixed-term-deposits">Term Deposits Reports</b-link>
          <b-link class="collapse-item" :class="{ active: termTransactionsReports }"
            href="/reports/fixed-term-transactions">Term Transactions Reports</b-link>
          <b-link class="collapse-item" :class="{ active: otherPaymentReceipts }"
            href="/other-receipt-payment">Other Receipt/Payments</b-link>
        </div>
      </b-collapse>
    </b-nav-item>

    <hr class="sidebar-divider d-none d-md-block" />

    <b-nav-item v-b-toggle.collapse-7 :class="{ active: voucher }">
      <font-awesome-icon :icon="['fas', 'book']" /><span>Vouchers</span>
      <b-collapse id="collapse-7" :visible="voucherVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link class="collapse-item" :class="{ active: addVoucher }" href="/voucher/create">Create Voucher</b-link>
          <b-link class="collapse-item" :class="{ active: voucherIndex }" href="/voucher">
            <CustomTooltip :message="allVoucherHoverDetailDiplay" :is-html="true"
              :background="'rgba(1, 134, 114, 0.6) '" :color="'#ffffff'" :offsetY="30">
              All Vouchers
              <small class="ms-1" :class="statusBadge('Approved')">{{ allVoucherData.Approved.count }}</small>
              <small class="ms-1" :class="statusBadge('Pending')">{{ allVoucherData.Pending.count }}</small>
              <!-- <small class="ms-1" :class="statusBadge('Rejected')">{{ allJournalsData.closedCount }}</small> -->
            </CustomTooltip>
          </b-link>
        </div>
      </b-collapse>
    </b-nav-item>

    <hr class="sidebar-divider d-none d-md-block" />

    <b-nav-item v-b-toggle.collapse-8 :class="{ active: journal }">
      <font-awesome-icon :icon="['fas', 'tasks']" /><span>Journals</span>
      <b-collapse id="collapse-8" :visible="journalVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link class="collapse-item" :class="{ active: addJournal }" href="/journal/create">Create Journal</b-link>
          <b-link class="collapse-item" :class="{ active: addOpeningOrClosingJournal }" href="/journal/create-opening-closing">Financial Year Transition</b-link>
          <b-link class="collapse-item" :class="{ active: journalIndex }" href="/journal">
            <CustomTooltip :message="allJournalsHoverDetailDiplay" :is-html="true"
              :background="'rgba(1, 134, 114, 0.6) '" :color="'#ffffff'" :offsetY="30">
              All Journals
              <small class="ms-1" :class="statusBadge('Approved')">{{ allJournalsData.Approved.count }}</small>
              <small class="ms-1" :class="statusBadge('Pending')">{{ allJournalsData.Pending.count }}</small>
              <!-- <small class="ms-1" :class="statusBadge('Rejected')">{{ allJournalsData.closedCount }}</small> -->
            </CustomTooltip>
          </b-link>
          <b-link class="collapse-item" :class="{ active: journalTransferIndex }" href="/journal/transfer">Member
            Transfer</b-link>
          <b-link class="collapse-item" :class="{ active: journalImport }" href="/journal/import">Import</b-link>
        </div>
      </b-collapse>
    </b-nav-item>

    <hr class="sidebar-divider d-none d-md-block" />
    <div class="sidebar-heading">Loans</div>
    <!-- Loan -->
    <b-nav-item v-b-toggle.collapse-9 :class="{ active: loan }">
      <font-awesome-icon :icon="['fas', 'hand-holding']" /><span>Loans</span>
      <b-collapse id="collapse-9" :visible="loanVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link class="collapse-item" :class="{ active: allLoans }" href="/loans">
            <CustomTooltip :message="allLoansHoverDetailDiplay" :max-width="'300px'" :is-html="true"
              :background="'rgba(1, 134, 114, 0.6) '" :color="'#ffffff'" :offsetY="30">
              All Loans
              <small class="ms-1" :class="statusBadge('Approved')">{{ allLoansData.runningCount }}</small>
              <small class="ms-1" :class="statusBadge('Pending')">{{ allLoansData.pendingCount }}</small>
              <small class="ms-1" :class="statusBadge('Rejected')">{{ allLoansData.closedCount }}</small>
            </CustomTooltip>
          </b-link>
          <b-link class="collapse-item" :class="{ active: loanTransaction }" href="/loans/transactions">All
            Transactions</b-link>
          <b-link class="collapse-item" :class="{ active: addLoan }" href="/loans/application">Loan Application</b-link>
          <b-link class="collapse-item" :class="{ active: repayLoan }" href="/loans/repayments">Loan Repayments</b-link>
          <b-link class="collapse-item" :class="{ active: loanCal }" href="/loans/calculator">Loan Calculator</b-link>
          <b-link class="collapse-item" :class="{ active: loanScheme }" href="/loans/scheme">Loan Schemes</b-link>
          <!-- <b-link class="collapse-item" :class="{ active: loanImport }" href="/loans/import">Loan Imports</b-link> -->
          <!-- <b-link class="collapse-item" :class="{ active: loanBulkReymentsUpload }" href="/loans/bulk/repayments/upload">Repayment Imports</b-link> -->
          <b-link class="collapse-item" :class="{ active: loanImports }" href="/loans/import">Imports</b-link>

        </div>
      </b-collapse>
    </b-nav-item>

    <!-- Divider -->
    <hr class="sidebar-divider" />

    <!-- Heading -->
    <div class="sidebar-heading">Financials</div>

    <!-- COA Management -->
    <b-nav-item v-b-toggle.collapse-1 :class="{ active: accounts }">
      <font-awesome-icon :icon="['fas', 'chart-bar']" /><span>Chart Of Accounts</span>
      <b-collapse :visible="accountsVisible" id="collapse-1">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link class="collapse-item" :class="{ active: allAccountTypes }" href="/chart-of-accounts/account-types">COA
            Types</b-link>
          <b-link class="collapse-item" :class="{ active: allCoa }" href="/chart-of-accounts">Accounts</b-link>
          <b-link class="collapse-item" :class="{ active: coaImports }"
            href="/chart-of-accounts/import">Imports</b-link>
          <b-link class="collapse-item" :class="{ active: coaReconcile }" href="/chart-of-accounts/reconcile">COA
            Reconcile</b-link>
          <b-link class="collapse-item" :class="{ active: coaMerge }" href="/chart-of-accounts/merge-coa">Merge
            COA</b-link>
          <b-link class="collapse-item" v-if="coa_trans" :class="{ active: coaTransactions }"
            href="/chart-of-accounts/transactions">
            COA Transactions
          </b-link>
          <!-- <b-link class="collapse-item" :class="{ active: coasubImports }" href="/chart-of-accounts/sub/import">COASub Imports</b-link> -->
        </div>
      </b-collapse>
    </b-nav-item>

    <hr class="sidebar-divider d-none d-md-block" />

    <!-- Heading -->
    <div class="sidebar-heading">user management</div>

    <!-- User Management -->
    <b-nav-item v-b-toggle.collapse-2 :class="{ active: users }">
      <font-awesome-icon :icon="['fas', 'user']" /><span>Users</span>
      <b-collapse :visible="userVisible" id="collapse-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link class="collapse-item" :class="{ active: addUsers }" href="/users/create">Create User</b-link>
          <b-link class="collapse-item" :class="{ active: allUsers }" href="/users">All Users</b-link>
          <b-link class="collapse-item" :class="{ active: permissions }" href="/users/permissions">Roles /
            Permissions</b-link>
          <b-link class="collapse-item" :class="{ active: attendance }" href="/users/attendance">Attendance</b-link>
          <b-link class="collapse-item" v-if="audit_trail" :class="{ active: audit }" href="/users/audit">Audit</b-link>
        </div>
      </b-collapse>
    </b-nav-item>

    <!-- Divider -->
    <hr class="sidebar-divider d-none d-md-block" />

    <div class="sidebar-heading">Settings</div>

    <b-nav-item v-b-toggle.collapse-10 :class="{ active: branch }">
      <font-awesome-icon :icon="['fas', 'code-branch']" /><span>Branches</span>
      <b-collapse id="collapse-10" :visible="branchVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link class="collapse-item" :class="{ active: addBranch }" href="/branch/create">Create Branch</b-link>
          <b-link class="collapse-item" :class="{ active: allBranch }" href="/branch">All Branches</b-link>
          <b-link class="collapse-item" :class="{ active: importRegion }" href="/region/imports">Imports</b-link>
        </div>
      </b-collapse>
    </b-nav-item>
    <hr class="sidebar-divider" />
    <!-- Insititute Details -->
    <li class="nav-item" :class="{ active: institution }">
      <a class="nav-link" href="/institution">
        <font-awesome-icon :icon="['fas', 'university']" />
        <span>Insitution Details</span>
      </a>
    </li>

    <hr class="sidebar-divider" />
    <!-- Financial Year -->
    <li class="nav-item" :class="{ active: financial_year }">
      <a class="nav-link" href="/financial-year">
        <font-awesome-icon :icon="['fas', 'calendar-week']" /><span>Financial Years</span>
      </a>
    </li>

    <hr class="sidebar-divider" />
    <!-- Account type -->
    <b-nav-item v-b-toggle.collapse-11 :class="{ active: accType }">
      <font-awesome-icon :icon="['fas', 'user-circle']" /><span>Product Types</span>
      <b-collapse id="collapse-11" :visible="accTypeVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link class="collapse-item" :class="{ active: addAccType }" href="/members/account-type/create">Create
            Product Type</b-link>
          <b-link class="collapse-item" :class="{ active: allMemType }" href="/members/account-type">All Product
            Types</b-link>
        </div>
      </b-collapse>
    </b-nav-item>

    <hr class="sidebar-divider" />
    <!-- Excel Export Details -->
    <li class="nav-item" :class="{ active: institution }">
      <a class="nav-link" href="/settings/excel/export">
        <font-awesome-icon :icon="['fas', 'file-excel']" />
        <span>Excel Exports</span>
      </a>
    </li>

    <hr v-if="api_key" class="sidebar-divider" />
    <!-- Account type -->
    <b-nav-item v-b-toggle.collapse-12 v-if="api_key" :class="{ active: api }">
      <font-awesome-icon :icon="['fas', 'key']" /><span>API Key</span>
      <b-collapse id="collapse-12" :visible="apiVisible" class="mt-2">
        <div class="py-2 collapse-inner" @click.stop>
          <b-link class="collapse-item" :class="{ active: apiKey }" href="/settings/generate/apikey">Generate API
            Key</b-link>
          <!-- <b-link class="collapse-item" :class="{ active: allMemType }" href="/members/account-type">All Product
            Types</b-link> -->
        </div>
      </b-collapse>
    </b-nav-item>

    <hr class="sidebar-divider" />

    <!-- SMS -->
    <li class="nav-item" :class="{ active: sms }">
      <a class="nav-link" href="/settings/sms">
        <font-awesome-icon :icon="['fas', 'envelope']" />
        <span>Sms</span>
      </a>
    </li>

    <!-- AI -->
     <hr class="sidebar-divider d-none d-md-block" />
    <!-- Heading -->
    <div class="sidebar-heading">AI</div>
    <!-- AI Document -->
    <li class="nav-item" :class="{ active: aiUpload }">
      <a class="nav-link" href="/ai/documentUpload">
        <font-awesome-icon :icon="['fas', 'user']" /><span>Upload Document</span>
      </a>
    </li>

    <!-- Divider -->
    <hr class="sidebar-divider d-none d-md-block" />
    <!-- Heading -->
    <div class="sidebar-heading">Reports</div>
    <!-- Settings -->
    <li class="nav-item" :class="{ active: reports }">
      <a class="nav-link" href="/reports">
        <font-awesome-icon :icon="['fas', 'book']" /><span>Reports</span>
      </a>
    </li>

    <!-- transactions -->
    <!-- <b-nav-item v-b-toggle.collapse-6 :class="{ active: transactions }">  
        <font-awesome-icon :icon="['fas', 'exchange-alt']" /><span>Transactions</span>
        <b-collapse id="collapse-6" :visible="transactionsVisible" class="mt-2">
            <div class="py-2 collapse-inner" @click.stop>
                <b-link class="collapse-item" :class="{ active: deposit }"  href="/deposit">Deposit</b-link>
                <b-link class="collapse-item" :class="{ active: withdrawals }"  href="/withdrawal">Withdrawals</b-link>
            </div>
        </b-collapse>
    </b-nav-item> -->

    <!-- Divider -->
    <hr class="sidebar-divider d-none d-md-block" />
  </ul>
  <!-- End of Sidebar -->
</template>
<script>
import ApiService from "@/core/services/api.service";
import { decryptData } from '@/crypto';
import { hasPermission } from '@/helper';
import CustomTooltip from "@/views/components/CustomTooltip.vue";
export default {

  name: "SidebarView",
  // This are properties for active sidebar
  props: [
    "home",
    "users",
    "allUsers",
    "addUsers",
    "userVisible",
    "roles",
    "permissions",
    "branch",
    "branchVisible",
    "addBranch",
    "allBranch",
    "members",
    "memberVisible",
    "addMember",
    "allMember",
    "allAccountTypes",
    "accounts",
    "allCoa",
    "accountsVisible",
    "loan",
    "allLoans",
    "loanVisible",
    "loanCal",
    "loanScheme",
    "deposit",
    "withdrawal",
    "memacc",
    "memaccVisible",
    "addMemAcc",
    "allMemAcc",
    "memberImport",
    "transVisible",
    "operation",
    "operationsVisible",
    "allTransaction",
    "bulkTransaction",
    'bulkWithdrawals',
    "transaction",
    "depositTransaction",
    "withdrawalTransaction",
    "addLoan",
    "repayLoan",
    "accType",
    "addAccType",
    "allMemType",
    "accTypeVisible",
    "institution",
    "financial_year",
    "reports",
    "fixed_deposit",
    "voucher",
    "voucherVisible",
    "addVoucher",
    "voucherIndex",
    "journal",
    "journalVisible",
    "addJournal",
    "addOpeningOrClosingJournal",
    "journalIndex",
    "standing_order",
    "mobile",
    "journalTransferIndex",
    "loanImports",
    "coasubImports",
    "coaImports",
    "importRegion",
    "importMembers",
    "fdScheme",
    "transactionImports",
    "attendance",
    "operationImport",
    "termDepositsReports",
    "termTransactionsReports",
    "apiKey",
    "api",
    "apiVisible",
    "coaReconcile",
    'journalImport',
    'loanTransaction',
    "audit",
    "coaTransactions",
    "coaMerge",
    "fixed_deposit_trans",
    "roTransfer",
    "chequeProcessing",
    "sms",
    "commissionTransfer",
    "otherPaymentReceipts",
    "aiUpload"
  ],
  components: {
    CustomTooltip
  },
  data() {
    return {
      memberData: {
        approved_customer_count: 0,
        pending_customer_count: 0,
        rejected_customer_count: 0,
        male: 0,
        female: 0,
        group: 0,
        corporate: 0,
      },
      productData: {
        account: {
          pending: 0,
          active: 0,
          dormant: 0,
        },
        dailySavings: {
          male: 0,
          female: 0,
          total: 0
        },
        memberSavings: {
          male: 0,
          female: 0,
          total: 0
        }
      },
      depositAndWithdrawalData: {
        count: {
          pending: 0,
          completed: 0,
          reversed: 0
        },
        value: {
          pending: 0,
          completed: 0,
          reversed: 0
        }
      },
      fixed_deposit_summary:
      {
        Pending: { count: 0, value: 0 },
        Matured: { count: 0, value: 0 },
        Redeemed: { count: 0, value: 0 },
      },
      allLoansData: {
        pendingCount: 0,
        runningCount: 0,
        closedCount: 0,
        normalLoan: {
          count: 0,
          value: 0
        },
        businessLoan: {
          count: 0,
          value: 0
        }
      },
      allJournalsData: {
        Pending: {
          count: 0,
          value: 0
        },
        Approved: {
          count: 0,
          value: 0
        },

      },
      allVoucherData: {
        Pending: {
          count: 0,
          value: 0
        },
        Approved: {
          count: 0,
          value: 0
        },

      },
      noPendingMemberAccounts: 0,
      noApprovedMemberAccounts: 0,
      noRejectedMemberAccounts: 0,
      windowWidth: window.innerWidth,
      user_permissions: "",
      permission_state: {
        add_user: false,
        edit_user: false,
        view_user: false,
        roles_and_permissions: false,
        add_voucher: false,
        view_voucher: false,
        edit_voucher: false,
      },
      productSummary: {
        pending: 0,
        closed: 0,
      },
      audit_trail: false,
      user_branch: "",
      api_key: false,
      coa_trans: false,
      prevActiveID: null,
      prevActiveBool: null,
      loan_products: [],
      accountProduct: [],
    };
  },
  mounted() {

    if (!this.mobile) {
      this.$nextTick(() => {
        const element = this.$refs.sidebar;
        window.addEventListener("resize", this.onResize);
        if (this.windowWidth < 768) {
          element?.classList?.add("toggled");
          // console.log(this.mobile);
        } else {
          element?.classList?.remove("toggled");
        }
      });
      this.user_branch = decryptData(localStorage.getItem("user_branch"));
    }
    this.checkPemission();
    this.getMemberInfo()

    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (isJustShown) {
        if (this.prevActiveID && this.prevActiveID !== collapseId) {
          // Close the previously active collapse
          this.$root.$emit('bv::toggle::collapse', this.prevActiveID);
        }
        // Update current active
        this.prevActiveID = collapseId;
      } else if (this.prevActiveID === collapseId) {
        // If the collapse was just hidden, clear the active ID
        this.prevActiveID = null;
      }

      // console.log('Active Collapse:', this.prevActiveID);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  computed: {
    memberHoverDetailDiplay() {
      return `
      Males : <strong>${this.displayCountingNumber(this.memberData.male)}</strong><br/>
      Females : <strong>${this.displayCountingNumber(this.memberData.female)}</strong><br/>
      Group : <strong>${this.displayCountingNumber(this.memberData.group)}</strong><br/>
      Corporate : <strong>${this.displayCountingNumber(this.memberData.corporate)}</strong><br/><br/>
      Total : <strong>${this.displayCountingNumber(this.getMemberTotal)}</strong>
      `;
    },
    // allProductHoverDetailDiplay() {
    //   return `
    //   <small class="fw-bolder">${"Daily Savings".toLocaleUpperCase()} </small> <br />
    //   <div class="ms-2">
    //     Males : <strong>${this.displayCountingNumber(this.productData.dailySavings.male)}</strong><br/>
    //     Females : <strong>${this.displayCountingNumber(this.productData.dailySavings.female)}</strong><br/><br/>
    //     Total : <strong>${this.displayCountingNumber(this.getTotal(this.productData.dailySavings.male, this.productData.dailySavings.female))}</strong>
    //   </div><br />
    //   <small class="fw-bolder">${"Member Savings".toLocaleUpperCase()} </small> <br />
    //   <div class="ms-2">
    //     Males : <strong>${this.displayCountingNumber(this.productData.memberSavings.male)}</strong><br/>
    //     Females : <strong>${this.displayCountingNumber(this.productData.memberSavings.female)}</strong><br/><br/>
    //     Total : <strong>${this.displayCountingNumber(this.getTotal(this.productData.memberSavings.male, this.productData.memberSavings.female))}</strong>
    //   </div><br />
    //     `
    // },
    allProductHoverDetailDiplay() {
      return `${this.accountProduct.map(index => '<small class="fw-bolder">' + index.name.toLocaleUpperCase() + '</small>' + '<br/>' + '<div class="ms-2">' + 'Male : ' + '<strong>' + index.male_count + '</strong>' + '<br/>' + 'Female : ' + '<strong>' + index.female_count + '</strong>' + '<br/>' + '</div>' + '<hr class="m-0"/>').join('')}`;
    },
    getMemberTotal() {
      const total = this.memberData.male + this.memberData.female + this.memberData.group + this.memberData.corporate;
      return total;
    },
    depositAndWithdrawalrHoverDetailDiplay() {
      return `
      Pending ${this.depositAndWithdrawalData.count.pending} : <strong>${this.displayNumber(this.depositAndWithdrawalData.value.pending)}</strong><br/>
      Completed ${this.depositAndWithdrawalData.count.completed} : <strong>${this.displayNumber(this.depositAndWithdrawalData.value.completed)}</strong><br/>
      Rejected ${this.depositAndWithdrawalData.count.reversed} : <strong>${this.displayNumber(this.depositAndWithdrawalData.value.reversed)}</strong><br/><br/>
      Total ${this.getTotal(this.getTotal(this.depositAndWithdrawalData.count.pending, this.depositAndWithdrawalData.count.completed), this.depositAndWithdrawalData.count.reversed)}
      : <strong>${this.displayNumber(this.getTotal(this.getTotal(this.depositAndWithdrawalData.value.pending, this.depositAndWithdrawalData.value.completed), this.depositAndWithdrawalData.value.reversed))}</strong>
      `;
    },
    fixedDepositHoverDetailDiplay() {
      return `
      Pending ${this.fixed_deposit_summary?.count?.pending} : <strong>${this.displayNumber(this.fixed_deposit_summary?.value?.pending)}</strong><br/>
      Matured ${this.fixed_deposit_summary?.count?.matured} : <strong>${this.displayNumber(this.fixed_deposit_summary?.value?.matured)}</strong><br/>
      Redeemed ${this.fixed_deposit_summary?.count?.redeemed} : <strong>${this.displayNumber(this.fixed_deposit_summary?.value?.redeemed)}</strong><br/><br/>
      Total ${this.getTotal(this.getTotal(this.fixed_deposit_summary?.count?.pending, this.fixed_deposit_summary?.count?.matured), this.fixed_deposit_summary?.count?.redeemed)}
      : <strong>${this.displayNumber(this.getTotal(this.getTotal(this.fixed_deposit_summary?.value?.pending, this.fixed_deposit_summary?.value?.matured), this.fixed_deposit_summary?.value?.redeemed))}</strong>
      `;
    },
    // allLoansHoverDetailDiplay() {
    //   return `
    //   Normal Loan ${this.allLoansData.normalLoan.count} : <strong>${this.displayNumber(this.depositAndWithdrawalData.pending.value)}</small><br/>
    //   Business Loan ${this.allLoansData.businessLoan.count} : <strong>${this.displayNumber(this.depositAndWithdrawalData.completed.value)}</small><br/><br/>
    //   Total ${this.getTotal(this.allLoansData.normalLoan.count, this.allLoansData.businessLoan.count)}
    //   : <strong>${this.displayNumber(this.getTotal(this.allLoansData.normalLoan.value, this.allLoansData.businessLoan.value))}</small>
    //   `;
    // },
    allLoansHoverDetailDiplay() {
      return `
        ${this.loan_products.map(index => index.loan_product_name + ' ~ ' + index.count + ' : <strong>' + this.displayNumber(index.total_amount) + '</strong><br/> <hr class="my-1"/>').join('')}`;
    },
    allJournalsHoverDetailDiplay() {
      return `
      Pending ${this.allJournalsData.Pending.count} : <strong>${this.displayNumber(this.allJournalsData.Pending.value)}</strong><br/>
      Approved ${this.allJournalsData.Approved.count} : <strong>${this.displayNumber(this.allJournalsData.Approved.value)}</strong><br/><br/>
      Total ${this.getTotal(this.allJournalsData.Pending.count, this.allJournalsData.Approved.count)}
      : <strong>${this.displayNumber(this.getTotal(this.allJournalsData.Pending.value, this.allJournalsData.Approved.value))}</strong>
      `;
    },
    allVoucherHoverDetailDiplay() {
      return `
      Pending ${this.allVoucherData.Pending.count} : <strong>${this.displayNumber(this.allVoucherData.Pending.value)}</strong><br/>
      Approved ${this.allVoucherData.Approved.count} : <strong>${this.displayNumber(this.allVoucherData.Approved.value)}</strong><br/><br/>
      Total ${this.getTotal(this.allVoucherData.Pending.count, this.allVoucherData.Approved.count)}
      : <strong>${this.displayNumber(this.getTotal(this.allVoucherData.Pending.value, this.allVoucherData.Approved.value))}</strong>
      `;
    },
  },
  methods: {
    checkPemission() {
      // console.log(hasPermission())
      this.audit_trail = hasPermission('user_management_audit');
      this.api_key = hasPermission('financial_management_api_key');
      this.coa_trans = hasPermission('financial_management_coa_transaction');
    },
    closeTabs() {
      this.memaccVisible = false
      this.userVisible = false;
      this.branchVisible = false;
      this.memberVisible = false;
      this.accountsVisible = false;
      this.loanVisible = false;
      this.memaccVisible = false;
      this.transVisible = false;
      this.operationsVisible = false;
      this.accTypeVisible = false;
      this.voucherVisible = false;
      this.journalVisible = false;

      console.log("called")
    },
    getMemberInfo() {
      ApiService.get("status-summary")
        .then(response => {
          this.memberData = response.data.customers
          // console.log(this.memberData);

          // All Loans data for hover
          this.allLoansData.runningCount = response.data.loans.running_loan_count
          this.allLoansData.pendingCount = response.data.loans.pending_loan_count
          this.allLoansData.closedCount = response.data.loans.closed_loan_count

          // Journal Data for hover
          this.allJournalsData.Approved.count = response.data.journals.approved_journal_count
          this.allJournalsData.Approved.value = response.data.journals.approved_journal_value
          this.allJournalsData.Pending.count = response.data.journals.pending_journal_count
          this.allJournalsData.Pending.value = response.data.journals.pending_journal_value

          // Journal Data for hover
          this.allVoucherData.Approved.count = response.data.vouchers.approved_voucher_count
          this.allVoucherData.Approved.value = response.data.vouchers.approved_voucher_value
          this.allVoucherData.Pending.count = response.data.vouchers.pending_voucher_count
          this.allVoucherData.Pending.value = response.data.vouchers.pending_voucher_value

          this.loan_products = response.data?.loan_products;

          this.fixed_deposit_summary = response.data.fixed_deposit;

          this.accountProduct = response.data.products;

          this.productSummary = response.data.product_summary;

          this.depositAndWithdrawalData = response.data.transaction_summary;

        }).catch((err) => {
          console.log(err)
          return [];  // Return an empty array in case of error to prevent the table from breaking
        });
    },
    statusBadge(state) {
      if (state === 'Approved') {
        return 'badge akkurate-blue'
      } else if (state === 'Pending') {
        return 'badge akkurate-orange'
      } else if (state === 'Rejected') {
        return 'badge akkurate-danger-bg'
      }
    },

    getTotal(a, b) {
      return a + b;
    }
  }

};
</script>